import { IS_PRODUCT } from './env';

//* 프로덕션 유닛 ID
const AD_UNIT_IDS_PROD = {
  // HOME_NATIVE_POLICY: '01KH0SX305FWBDWKWXHBZCEVNY', //* 홈 > 인기정책 섹션 카드
  // HOME_NATIVE_BM_TOP: '01KJY6SCVZ065MG38WAMHVHDDW', //* 홈 > BM 상단 카드
  // HOME_NATIVE_BM_BOTTOM: '01KJY6TVQM7DJQ184EGDWFPY6X', //* 홈 > BM 하단 카드
  // POLICY_DETAIL: '01KJVX5VAF2AYDY24WMGQPDXFE', //* 맞춤정책 상세 > 본문 상단
  // BENEFIT_POLICY_GUIDE: '01KK8WFVBQV8CQ8SJ4282SWNPV', //* 혜택탭 > 정책활용가이드 (web_혜택_정책_네이티브)
  // BENEFIT_BM: '01KJY6Q3GEY6MK6S277NND9QDF', //* 혜택탭 > BM 배너
  // MY_INFO_TAX: '01KKAJTHPZG03190P945KS9HK5', //* 더보기 > 연말정산 하단 (web_더보기_중간_네이티브)
  DONATION_HOME_TOP: '01KJVXWJTBHW2J3J86R8T7YT2A', //* 고기부 홈 > 상단 배너
  HOME_FEED_LIST_BANNER_M: '01KQ6T9KZRGH1YZEQSAH0EHTV4', //* 홈 피드 목록 > 모바일 배너 320x50
  HOME_FEED_LIST_BANNER_P: '01KQ6TCR4YWPPC0NNH9TGCRHXH', //* 홈 피드 목록 > PC 배너 600x314
  CONTENT_DETAIL_BOTTOM_BANNER: '01KG20GCDANJS0YKTPET4WAVF9', //* 정보/콘텐츠 상세 > 하단 배너
  GIFT_DETAIL_BOTTOM_BANNER: '01KG20GQTG7QB12B75BEQ9TG4V', //* 답례품 상세 > 하단 배너
  DESKTOP_SIDE_BANNER: '01KPZ0K96N63K3F12YJQPMR6Y5', //* 데스크톱 우측 사이드 250x250 배너 (TODO: 프로덕션 유닛 ID 발급 후 교체)
} as const;

//* 테스트 유닛 ID (TODO: 실제 테스트 유닛 ID로 교체)
const AD_UNIT_IDS_DEV = {
  // HOME_NATIVE_POLICY: '01KG4A9YWNPKQRS0QTTNHGM0QW',
  // HOME_NATIVE_BM_TOP: '01KG4AAE10DKVQW3GQSB4ETGNT',
  // HOME_NATIVE_BM_BOTTOM: '01KG4AATC27ASBBYZFKQ4RR6Z6',
  // POLICY_DETAIL: '01KG4AB87FN9TFJR7BDKQP501N',
  // BENEFIT_POLICY_GUIDE: '01KG4ABP53NEH60E6T3GKMDKCV',
  // BENEFIT_BM: '01KG4AC4PHNXZ1SAM2VK90JYBJ',
  // MY_INFO_TAX: '01KG4ACHHXZ4H42A9ARX0VS57F',
  DONATION_HOME_TOP: '01KG4ACZ56WVB8549F9TXSYBT8',
  HOME_FEED_LIST_BANNER_M: '01KQ6T9KZRGH1YZEQSAH0EHTV4',
  HOME_FEED_LIST_BANNER_P: '01KQ6TCR4YWPPC0NNH9TGCRHXH',
  CONTENT_DETAIL_BOTTOM_BANNER: '01KG4ADCY4DY9G0HJ2M4AD85N1', //* 정보/콘텐츠 상세 > 하단 배너
  GIFT_DETAIL_BOTTOM_BANNER: '01KG4ADSG8Q9CP8XRGDDMZPGJC',
  DESKTOP_SIDE_BANNER: '01KPZ0HPNAYXMPN4919DDQ5MVK', //* TODO: 테스트 유닛 ID로 교체
} as const;

export const AD_UNIT_IDS = IS_PRODUCT ? AD_UNIT_IDS_PROD : AD_UNIT_IDS_DEV;

